/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KomunikatTo } from '../../models/komunikat-to';

export interface ApiWebInstytucjeNipKomunikatyGet$Params {
  nip: string;

/**
 * Ile komunikatów zwrócić.
 */
  ilosc?: number;

/**
 * Opcjonalna kategoria do filtrowania.
 */
  kategoria?: string;

/**
 * Od którego komunikatu zacząć, numerowane od 0.
 */
  od?: number;

/**
 * Po której kolumnie sortować.
 */
  orderByColumn?: any;

/**
 * Kierunek sortowania.
 */
  orderByDirection?: any;
}

export function apiWebInstytucjeNipKomunikatyGet(http: HttpClient, rootUrl: string, params: ApiWebInstytucjeNipKomunikatyGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<KomunikatTo>>> {
  const rb = new RequestBuilder(rootUrl, apiWebInstytucjeNipKomunikatyGet.PATH, 'get');
  if (params) {
    rb.path('nip', params.nip, {});
    rb.query('ilosc', params.ilosc, {});
    rb.query('kategoria', params.kategoria, {});
    rb.query('od', params.od, {});
    rb.query('orderByColumn', params.orderByColumn, {});
    rb.query('orderByDirection', params.orderByDirection, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<KomunikatTo>>;
    })
  );
}

apiWebInstytucjeNipKomunikatyGet.PATH = '/api/web/instytucje/{nip}/komunikaty';
